export default "__VITE_ASSET__BwCGUjCt__"